import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl};
  background-color: ${props => props.theme.colors.background};
  text-align: center;
`;

const Title = styled.h2`
  font-size: ${props => props.theme.typography.fontSize.h2};
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: ${props => props.theme.spacing.xl};
`;

const AnalysisContainer = styled.div`
  max-width: 600px;
  width: 100%;
`;

const AnalysisStep = styled(motion.div)`
  margin-bottom: ${props => props.theme.spacing.lg};
  text-align: left;
`;

const StepTitle = styled.h3`
  font-size: 1rem;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: ${props => props.theme.spacing.sm};
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.small};
  overflow: hidden;
`;

const Progress = styled(motion.div)`
  height: 100%;
  background-color: ${props => props.theme.colors.primary};
  border-radius: ${props => props.theme.borderRadius.small};
`;

const AnalysisScreen = ({ onComplete }) => {
  const steps = [
    'Hauttyp wird analysiert',
    'Alterungsrisiko wird berechnet',
    'Personalisierte Lösung wird gefunden',
    'Empfehlung wird generiert'
  ];
  const [progresses, setProgresses] = useState([0, 0, 0, 0]);

  useEffect(() => {
    let timeouts = [];
    // Animate each bar to fill over 6 seconds, staggered
    steps.forEach((_, i) => {
      timeouts.push(setTimeout(() => {
        setProgresses(prev => prev.map((p, idx) => idx === i ? 100 : p));
      }, (i * 1500)));
    });
    // Complete after 6 seconds
    const timer = setTimeout(() => {
      onComplete();
    }, 6000);
    return () => {
      timeouts.forEach(clearTimeout);
      clearTimeout(timer);
    };
  }, [onComplete]);

  return (
    <Container>
      <Title>Ihre Hautanalyse wird erstellt...</Title>
      
      <AnalysisContainer>
        {steps.map((step, index) => (
          <AnalysisStep
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.5 }}
          >
            <StepTitle>{step}</StepTitle>
            <ProgressBar>
              <Progress
                initial={{ width: 0 }}
                animate={{ width: `${progresses[index]}%` }}
                transition={{ duration: 1.5, ease: 'easeInOut' }}
              />
            </ProgressBar>
          </AnalysisStep>
        ))}
      </AnalysisContainer>
    </Container>
  );
};

export default AnalysisScreen; 